import { Box, Chip, Stack, Typography, useTheme } from "@mui/material";
import { memo } from "react";
import { TrendingAd } from "~src/types/ad";
import { Body } from "./Body";
import { Header } from "./Header";
import { fDate } from "~src/utils/formatTime";

const TrendingAdTileComponent = ({
  ad,
  onClick,
}: {
  ad: TrendingAd;
  onClick: VoidFunction;
}) => {
  const theme = useTheme();
  return (
    <Stack
      onClick={onClick}
      sx={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        height: "594px",
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: "12px",
        backgroundColor: theme.palette.common.white,
        overflow: "hidden",
      }}
      data-testid="fb-ad-tile"
    >
      <Header ad={ad} />
      <Body ad={ad} />
      <TrendingAdMeta ad={ad} />
    </Stack>
  );
};

// Memoize to prevent unnecessary re-renders when parent component updates
export const TrendingAdTile = memo(TrendingAdTileComponent);

const TrendingAdMetaComponent = ({ ad }: { ad: TrendingAd }) => {
  const theme = useTheme();
  return (
    <Stack
      sx={{
        width: "100%",
        px: 2,
      }}
      data-testid="fb-ads-metadata"
    >
      <Box
        sx={{
          display: "flex",
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          py: 1,
        }}
      >
        <Typography variant="body2" sx={{ width: "80px" }}>
          Status
        </Typography>
        {ad.is_active ? (
          <Chip
            label="Active"
            color="success"
            icon={
              <Box
                sx={{
                  pl: 1,
                }}
              >
                <Box
                  sx={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "3px",
                    backgroundColor: theme.palette.success.main,
                  }}
                />
              </Box>
            }
          />
        ) : (
          <Chip
            label="Inactive"
            color="error"
            icon={
              <Box
                sx={{
                  pl: 1,
                }}
              >
                <Box
                  sx={{
                    width: "6px",
                    height: "6px",
                    borderRadius: "3px",
                    backgroundColor: theme.palette.error.main,
                  }}
                />
              </Box>
            }
          />
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          borderBottom: `1px solid ${theme.palette.grey[200]}`,
          py: 1,
        }}
      >
        <Typography variant="body2" sx={{ width: "80px" }}>
          Start
        </Typography>
        <Typography variant="body2">{fDate(ad.start_date)}</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
        }}
      >
        <Typography variant="body2" sx={{ width: "80px" }}>
          ID
        </Typography>
        <Typography variant="body2">{ad.id}</Typography>
      </Box>
    </Stack>
  );
};

const TrendingAdMeta = memo(TrendingAdMetaComponent);
